import React, { useRef, useState } from "react";
import { Autocomplete } from "@react-google-maps/api";
import axios from "axios";
import { useNavigate } from "react-router-dom";

const API_BASE = process.env.REACT_APP_API_BASE;

const PostRideRequest = () => {
  const fromRef = useRef(null);
  const toRef = useRef(null);
  const navigate = useNavigate();
  const customerId = localStorage.getItem("customerId");

  const [date, setDate] = useState("");
  const [seatsNeeded, setSeatsNeeded] = useState(1);
  const [notes, setNotes] = useState("");

  // ✅ Redirect unauthenticated users cleanly
  if (!customerId) {
    navigate("/login", { replace: true });
    return null;
  }

  const handleSubmit = async () => {
    const from = fromRef.current?.value;
    const to = toRef.current?.value;

    if (!from || !to || !date || !seatsNeeded) {
      alert("❌ Please fill all fields");
      return;
    }

    try {
      await axios.post(`${API_BASE}/api/ride/customer/request`, {
        customerId,
        from,
        to,
        date,
        seatsNeeded: parseInt(seatsNeeded),
        notes,
      });

      alert("✅ Your ride request has been posted successfully!");
      navigate("/customer-dashboard");
    } catch (err) {
      console.error("❌ Failed to post ride request:", err);
      alert("❌ Failed to post request. Please try again.");
    }
  };

  return (
    <div className="min-h-screen flex justify-center items-start bg-blue-50 py-10 px-4">
      <div className="max-w-xl w-full bg-white p-6 rounded-xl shadow space-y-6">
        <h2 className="text-2xl font-bold text-blue-800 text-center">
          Post Your Ride Request
        </h2>

        <Autocomplete>
          <input
            ref={fromRef}
            placeholder="Pickup City"
            className="w-full border px-4 py-2 rounded-md"
          />
        </Autocomplete>

        <Autocomplete>
          <input
            ref={toRef}
            placeholder="Drop-off City"
            className="w-full border px-4 py-2 rounded-md"
          />
        </Autocomplete>

        <input
          type="date"
          value={date}
          onChange={(e) => setDate(e.target.value)}
          className="w-full border px-4 py-2 rounded-md"
        />

        <input
          type="number"
          min={1}
          value={seatsNeeded}
          onChange={(e) => setSeatsNeeded(e.target.value)}
          placeholder="Seats Needed"
          className="w-full border px-4 py-2 rounded-md"
        />

        <textarea
          value={notes}
          onChange={(e) => setNotes(e.target.value)}
          placeholder="Extra Notes (optional)"
          className="w-full border px-4 py-2 rounded-md"
        ></textarea>

        <button
          onClick={handleSubmit}
          className="w-full bg-green-600 hover:bg-green-700 text-white font-semibold py-2 rounded-md"
        >
          🚗 Post Ride Request
        </button>
      </div>
    </div>
  );
};

export default PostRideRequest;
